export default "__VITE_ASSET__92AP54NR__"